import React from "react";
import { triggerTealiumEvent } from "../../utils/tealiumUtils";
import { useLocation } from "@reach/router";
import NewWindow from "../../assets/new_window.inline.svg";
import GeneralAnchor from "../general-anchor/general-anchor.component";
import PropTypes from "prop-types";

const InfoCard = ({
  title,
  description,
  linkText,
  linkHref,
  linkClass = "",
  colClass = "col-xs-12 col-xl-3",
  backgroundColor = "",
  showNewWindowIcon = true,
  tealiumEventName = "",
  tealiumCategory = "content",
  tealiumAction = "button",
  tealiumLabel = "product information",
  tealiumPage = "Home",
}) => {
  const location = useLocation();

  const handleClick = () => {
    if (tealiumEventName) {
      triggerTealiumEvent(
        "link",
        location.href,
        tealiumCategory,
        tealiumAction,
        tealiumEventName,
        tealiumLabel,
        tealiumPage,
        ""
      );
    }
  };

  const cardStyle = backgroundColor ? { backgroundColor } : {};

  return (
    <div className={colClass}>
      <div className="info-card" style={cardStyle}>
        <h2>{title}</h2>
        <p>{description}</p>
        <GeneralAnchor
          isBlank
          href={linkHref}
          rel="noreferrer"
          isLink={true}
          additionalClass={linkClass}
          onClick={() => handleClick()}
        >
          {linkText}
          {showNewWindowIcon && <NewWindow />}
        </GeneralAnchor>
      </div>
    </div>
  );
};

InfoCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  linkHref: PropTypes.string.isRequired,
  linkClass: PropTypes.string,
  colClass: PropTypes.string,
  backgroundColor: PropTypes.string,
  showNewWindowIcon: PropTypes.bool,
  tealiumEventName: PropTypes.string,
  tealiumCategory: PropTypes.string,
  tealiumAction: PropTypes.string,
  tealiumLabel: PropTypes.string,
  tealiumPage: PropTypes.string,
};

export default InfoCard;
